import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LanguageModel } from "../../models/api/language.model";
import { AppConfigService } from "../app-config.service";

@Injectable({
  providedIn: 'root'
})
export class ApiLanguageService {
  private readonly apiUrl: string;

  constructor(private readonly appConfigService: AppConfigService,
    private readonly httpClient: HttpClient) {
    this.apiUrl = this.appConfigService.getConfig().apiUrl;
  }


  public getAll(): Observable<LanguageModel[]> {
    const url = `${this.apiUrl}/api/Language/GetAll`;

    return this.httpClient.get<LanguageModel[]>(url);
  }
}
